import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Routing } from '../../modules/routing'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'profileNotification', {
  title: 'Notifications',
  previous: 'Précédent',
})

Locale.getInstance().registerKeySet('en', 'profileNotification', {
  title: 'Notifications',
  previous: 'Previous',
})

export interface LvcProfileNotificationModal {}

export class LvcProfileNotificationModal extends MinzeElement {
  modalId = MODALS.PROFILE_NOTIFICATION_MODAL

  onReady(): void | Promise<void> {}

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profile)
  }

  html = () => `
    <lvc-modal is-fullscreen-modal-scrollable="true" modal-id="${this.modalId}" left-title="true" show-when-logged="true" narrow="true" modal-title="${Locale.getKey('profileNotification.title')}">
      <div slot="lvc-modal-content">
        <lvc-profile-notification-modal-content></lvc-profile-notification-modal-content>
      </div>
    </lvc-modal>
  `

  css = () => `
    :host {

    }
    #link-back {
      cursor: pointer;
    }


  `

  eventListeners: EventListeners = [['#link-back', 'click', this.goBack]]
}
